import Bio from "../../aboutme/aboutme.component";
import NavigationComponent from "../../navigation/navigation.component";
import { Background, Paragraph, OppGradient, Gradient, Pink, MyImage} from "./about.styles";
import me from "../../images/games/Me.png"

const AboutPage = () => {
    return (
        <Background>
            <NavigationComponent></NavigationComponent>
            <Pink></Pink>
            <MyImage src={me}></MyImage>
            <Paragraph>Hi I'm BrieAnna, most people call me Brie and I am the creator of this website, BizzyBrie!
                I know you may be asking; what is this website for exactly?  Well its for showcasing my own skills and expertise.  
                We all have things that are good at that can't all be placed inside a single box.  I wanted to advertise my skills and services to any who are interested.</Paragraph>

                <Paragraph>I have been crocheting for 10 years now.  I have experience creating several items such as Amagarumi's, blankets, hats, scarfs, potholders and more. (Stay tuned for my craft portfolio!)</Paragraph>

                <Paragraph>I have been programming for 12 years.  I have experience programming within:
                    <ul>
                        <li>Programming Languages: JavaScript, C#, SQL</li>
                        <li>Software & Libraries: Unity, React, Styled Components</li>
                        <li>Other: HTML, CSS, Firebase</li>
                    </ul>
                </Paragraph>
                <Paragraph>I have played TTRPGs for approximately 8 years, and I became interested in Actual Plays about 4 years ago.  Since then, I have been in several Actual Play productions, all remote.</Paragraph>
        </Background>
    )
}

export default AboutPage;